import SettingsModel from './base_settings_model';
import DefaultSettings from '../../default_settings.js';

const settingsModel = new SettingsModel(DefaultSettings, {
    appName: 'wgni'
});

export default settingsModel;



// WEBPACK FOOTER //
// ./static-source/js/lib/settings_model.js